import {lazy} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {SuspensedView} from './SuspensedView'

/**
 * MAIN application routes (WMS S-25-05).
 * WMS is the main app. New modules are added HERE under the main area.
 * Metronic showcase/demo pages are kept separately in MetronicDemoRoutes
 * and mounted under /metronic/*.
 */
const PrivateRoutes = () => {
  const WmsRoutes = lazy(() => import('../wms/WmsRoutes'))
  const MetronicDemoRoutes = lazy(() => import('../metronic/MetronicDemoRoutes'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to WMS orders after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/wms/orders' />} />

        {/* ===== MAIN · WMS S-25-05 ===== */}
        <Route
          path='wms/*'
          element={
            <SuspensedView>
              <WmsRoutes />
            </SuspensedView>
          }
        />
        {/* ===== MAIN · new modules go here ===== */}

        {/* ===== Metronic demo (kept separate) ===== */}
        <Route
          path='metronic/*'
          element={
            <SuspensedView>
              <MetronicDemoRoutes />
            </SuspensedView>
          }
        />

        {/* Root → WMS orders */}
        <Route index element={<Navigate to='/wms/orders' />} />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

export {PrivateRoutes}
